/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react'
import { required } from 'validation-rules'
import { makeStyles } from '@material-ui/core'
import InfoSection from '../../shared/InfoSection'
import { TextareaType } from 'foundations-library/types'
import EmphasizedSection from '../../shared/EmphasizedSection'
import { Alert, Checkbox, Divider, RequiredAsterisk, Textarea, TextField, Typography } from 'foundations-library/components'
import { getValue } from 'firebase-utils'

const jss = (t) => {
    const { typography, colors } = t['foundations-library']
    return {
        inputLabel: {
            marginBottom: 15
        },
        mb10: {
            marginBottom: 10
        },
        mb30: {
            marginBottom: 30
        },
        inputContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 30
        },
        alert: {
            paddingLeft: 15,
            marginBottom: 10,
            '&.alert--info': {
                ...typography.body4,
                color: colors.neutral[700]
            }
        },
        requirements: {
            paddingLeft: 0
        }
    }
}

const useStyles = makeStyles(jss)

type PropsInterface = {
    inputType?: 'TextField' | 'Textarea'
    sample?: string,
    label?: string
    sampleTitle?: string,
    requirements?: string,
    isRequirementsConsentAcknowledged: boolean,
    onIsRequirementsConsentAcknowledgedChange(v: boolean): unknown
} & TextareaType

/**
 *
 */
const LabelTextareaInfo = ({
    inputType = 'Textarea',
    sample = '',
    label = '',
    sampleTitle,
    requirements,
    minHeight = 150,
    isRequirementsConsentAcknowledged,
    onIsRequirementsConsentAcknowledgedChange,
    ...props
}: PropsInterface): JSX.Element => {
    const styles = useStyles()
    return <div>
        <div>
            <Typography variant='body1' className={styles.inputLabel}>
                {label}<RequiredAsterisk />
            </Typography>
            {
                inputType === 'Textarea'
                    ? <Textarea
                        minHeight={minHeight}
                        {...props}
                        className={styles.textarea}
                    />
                    : <TextField {...props} />
            }
        </div>
        {requirements && !props.disabled && <InfoSection className={styles.requirements}>
            <div dangerouslySetInnerHTML={{ __html: requirements }} data-testid='textarea-requirements' />
        </InfoSection>}
        {
            !props.disabled && sample &&
            <EmphasizedSection color='rgba(217, 216, 216, 0.4)'>
                {
                    sampleTitle &&
                    <Typography variant='subtitle3' className={styles.mb10} color='neutral-900' data-testid='sample-description'>
                        {sampleTitle}
                    </Typography>
                }
                <Alert level='info' className={styles.alert}>
                    Using this script as written gives your campaign the best chance of fast approval. Paraphrasing or omitting elements is a common cause of rejection.
                </Alert>
                {
                    sample &&
                    <Typography variant='body3'>
                        <div dangerouslySetInnerHTML={{ __html: sample }} data-testid='textarea-info-section' />
                    </Typography>
                }
            </EmphasizedSection>
        }
        <Divider />
        <Checkbox
            checked={isRequirementsConsentAcknowledged}
            onChange={onIsRequirementsConsentAcknowledgedChange}
            rules={[required()]}
            disabled={props.disabled}
            data-testid='is-requirements-consent-acknowledged'
        >{getValue('sms_enrollment_campaigns_1st_step_requirements_acknowledge_label')}</Checkbox>
    </div>
}

export default LabelTextareaInfo
